import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { GET_FILTER_INVOICES } from './graphql/graphql.queries';
import { Invoice } from './invoice';

@Injectable({
    providedIn: 'root'
})
export class InvoiceService {
    constructor(private apollo: Apollo) {}

    getInvoicesWithFilters(searchText: string, filterText: string): Observable<Invoice[]> {
        return this.apollo
            .use('invoiceGrapql')
            .watchQuery<Invoice[]>({
                query: GET_FILTER_INVOICES,
                variables: {
                    searchText: searchText,
                    filterStatus: filterText
                }
            })
            .valueChanges.pipe(map((results) => results.data));
    }
}
